import * as React from 'react';
export var useOnScroll = function () {
    var _a = React.useState(false), isScrolled = _a[0], setScrolled = _a[1];
    var onScroll = React.useCallback(function (e) {
        if (e.target.scrollTop > 0 && !isScrolled) {
            setScrolled(true);
        }
        else if (e.target.scrollTop === 0 && isScrolled) {
            setScrolled(false);
        }
    }, [isScrolled]);
    return [isScrolled, onScroll];
};
//# sourceMappingURL=hooks.js.map